import { render, staticRenderFns } from "./ColorKitPdp.vue?vue&type=template&id=3a06ea63&scoped=true&lang=pug&"
import script from "./ColorKitPdp.vue?vue&type=script&lang=js&"
export * from "./ColorKitPdp.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitPdp.vue?vue&type=style&index=0&id=3a06ea63&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06ea63",
  null
  
)

export default component.exports